import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCalendarCheck: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCalendarCheck"><Path d="M20.5 4.5H3.5V8.5H20.5V4.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M20.5 8.5V12.5" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 8.5V20.5H11.5" stroke="currentColor" strokeLinecap="square"/><Path d="M7.5 4.5V2.5" stroke="currentColor" strokeLinecap="square"/><Path d="M16.5 4.5V2.5" stroke="currentColor" strokeLinecap="square"/><Path d="M21.5 15.5L16.8333 21.5L14.5 19.1" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCalendarCheck;
